export default __webpack_public_path__ + "static/media/HostEmptystate.d574bab9.svg";